
import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const XeroCallbackHandler: React.FC = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    
    // Check if this is a Xero OAuth callback with authorization code
    if (code) {
      console.log('Xero OAuth callback detected, processing...');
      
      // Make the callback request to our server
      const processCallback = async () => {
        try {
          const response = await fetch(`${window.location.origin}/api/xero/callback${window.location.search}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Accept': 'application/json'
            }
          });
          
          const data = await response.json();
          
          if (response.ok) {
            console.log('OAuth callback successful:', data.message);
            // Close any modal by dispatching a custom event
            window.dispatchEvent(new CustomEvent('xero-auth-complete', { detail: { success: true } }));
            // Use history API to navigate without full page reload
            window.history.replaceState({}, document.title, '/xero-inventory');
            // Trigger a page reload to refresh the auth status
            window.location.reload();
          } else {
            console.error('OAuth callback failed:', data.error);
            window.location.href = `/xero-inventory?error=${encodeURIComponent('OAuth callback failed: ' + data.error)}`;
          }
        } catch (error) {
          console.error('Callback processing error:', error);
          window.location.href = `/xero-inventory?error=${encodeURIComponent('Network error during OAuth callback')}`;
        }
      };
      
      processCallback();
    } else {
      // If no code parameter, redirect back to xero inventory page
      console.log('No OAuth code found, redirecting to xero inventory...');
      window.location.href = '/xero-inventory';
    }
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh' }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="h6">Processing Xero authentication...</Typography>
      <Typography variant="body2" color="text.secondary">
        Redirecting to server...
      </Typography>
    </Box>
  );
};

export default XeroCallbackHandler;
